import { c as _c } from "react/compiler-runtime";
import { Button } from '@/app/components/button';
import { ButtonGroup } from '@/app/components/button-group';
import { AppImage } from '@/app/components/media/app-image';
import { MediaOverlayContent } from '@/app/lcv/components/sections/spartan/shared/media-overlay/content';
import { type MediaOverlayBannerContentProps } from '@/app/lcv/components/sections/spartan/shared/media-overlay/types';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
export const MEDIA_OVERLAY_BANNER_CLASS_NAME = 'md:min-h-100';

// Position of the content box; also the box the overlay gradient is sized against.
export const MEDIA_OVERLAY_BANNER_CONTENT_CLASS_NAME = 'inset-x-0 bottom-0 p-4 md:top-0 md:ml-auto md:mr-0 md:max-w-84 md:px-4 lg:max-w-100 xl:max-w-128 lg:py-12 lg:px-12 xl:px-18';
export const MEDIA_OVERLAY_BANNER_CONTENT_LAYOUT_CLASS_NAME = 'flex flex-col justify-between gap-y-4 md:justify-center md:gap-y-6';

// Fades content in when its slide becomes active; put on an inner box so the overlay isn't faded.
export const getMediaOverlayBannerContentFadeClassName = (isActive: boolean) => cn('transition duration-500 ease-out motion-reduce:transition-none', isActive ? 'translate-y-0 opacity-100 delay-300' : 'translate-y-4 opacity-0');
export const MediaOverlayBannerContent = t0 => {
  const $ = _c(29);
  const {
    item,
    testIds,
    tracking
  } = t0;
  const {
    title,
    description,
    logo,
    logoDesktop,
    logoClassName,
    buttons: t1
  } = item;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const buttons = t2;
  let t3;
  if ($[2] !== logo || $[3] !== logoClassName || $[4] !== logoDesktop || $[5] !== testIds.logo) {
    t3 = !!logo && <AppImage src={logo.src} alt={logo.alt} width={logo.width} height={logo.height} sizes="268px" customRatio={true} objectFit="contain" className={cn("mx-auto mb-2 flex w-full max-w-56 flex-col md:mb-4 md:max-w-64", {
      "md:hidden": !!logoDesktop
    }, logoClassName)} testId={testIds.logo} />;
    $[2] = logo;
    $[3] = logoClassName;
    $[4] = logoDesktop;
    $[5] = testIds.logo;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== logoClassName || $[8] !== logoDesktop || $[9] !== testIds.logoDesktop) {
    t4 = !!logoDesktop && <AppImage src={logoDesktop.src} alt={logoDesktop.alt} width={logoDesktop.width} height={logoDesktop.height} sizes="368px" customRatio={true} objectFit="contain" className={cn("mx-auto mb-4 hidden w-full max-w-92 flex-col md:flex", logoClassName)} testId={testIds.logoDesktop} />;
    $[7] = logoClassName;
    $[8] = logoDesktop;
    $[9] = testIds.logoDesktop;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== item.contentClassName) {
    t6 = cn("flex flex-auto flex-col justify-end", item.contentClassName);
    $[14] = item.contentClassName;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== description || $[17] !== t5 || $[18] !== t6 || $[19] !== testIds.header || $[20] !== title) {
    t7 = <MediaOverlayContent logo={t5} className={t6} title={title} description={description} descriptionClassName="lg:max-w-80 mx-auto" testId={testIds.header} />;
    $[16] = description;
    $[17] = t5;
    $[18] = t6;
    $[19] = testIds.header;
    $[20] = title;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== buttons || $[23] !== testIds || $[24] !== tracking) {
    t8 = buttons.length > 0 && <ButtonGroup {...createDataAttributes({
      test: testIds.buttonGroup
    })}>{buttons.map((button, index) => <Button key={button.href} href={button.href} color="white" width="full" className="mx-auto lg:w-67" variant={!!button.variant ? button.variant : "primary"} iconAfter={button.iconAfter} {...createDataAttributes({
        test: testIds.button(index)
      })} {...createDataGA({
        eventName: tracking.eventName,
        group: tracking.group,
        click: true,
        text: button.label,
        url: button.href
      })}>{button.label}</Button>)}</ButtonGroup>;
    $[22] = buttons;
    $[23] = testIds;
    $[24] = tracking;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t7 || $[27] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
};